module.exports = __webpack_public_path__ + "assets/1792649897182/img/failed-icon.662040d7.png";